import cx from 'classnames';
import * as React from 'react';

import { ICONS } from 'constants/IconConstants';

import './styles/Icon.scss';

export type IconColor =
  | 'currentColor'
  | 'apple'
  | 'elmer'
  | 'tuscan'
  | 'pencil'
  | 'leaf'
  | 'atlas'
  | 'pool'
  | 'ballpoint'
  | 'twilight'
  | 'mascot'
  | 'iris'
  | 'pennant'
  | 'chalkboard'
  | 'graphite'
  | 'percussion'
  | 'ruler'
  | 'paper'
  | 'whiteout'
  | 'google-sheets'
  | 'microsoft-excel'
  | 'ink';
export type IconName = keyof typeof ICONS;
export type IconSize = 'xxxlarge' | 'xxlarge' | 'xlarge' | 'large' | 'medium' | 'small' | 'inherit';

export type Props = {
  className?: string;
  color?: IconColor;
  name: IconName | null; // null renders an empty path node
  size?: IconSize;
  altText?: string;
};

function Icon({ className, color = 'currentColor', name, size = 'medium', altText }: Props) {
  const sizePx = 32;

  return (
    <svg
      width={sizePx}
      height={sizePx}
      viewBox={`0 0 ${sizePx} ${sizePx}`}
      className={cx('Icon', color && `Icon--${color}`, size && `Icon--${size}`, className)}>
      {altText && <title>{altText}</title>}
      <path d={name ? ICONS[name] : undefined} />
    </svg>
  );
}

export default Icon;
